module.exports = __webpack_public_path__ + "img/244-south-sudan.ca2f7d83.svg";